import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_EMPRESAS = "getEmpresas";
export const GET_EMPRESAS_LISTA = "getEmpresasEmitenteLista";

// mutation types
export const SET_EMPRESAS = "setEmpresas";

const state = {
    empresas: []
};

const getters = {
    empresas(state) {
        return state.empresas;
    }
};

const actions = {
    [GET_EMPRESAS](context) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.get("empresas").then(({ data }) => {
                    let empresasOrganizadas = [{
                        value: "0",
                        text: "Todas as empresas"
                    }];

                    data.forEach(function(item) {
                        empresasOrganizadas.push({
                            value: item.ID_EMPRESA,
                            text: item.DESCRICAO
                        });
                    });

                    context.commit(SET_EMPRESAS, empresasOrganizadas);
                    resolve(empresasOrganizadas);
                });
            }
        });
    },
    [GET_EMPRESAS_LISTA](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("empresasBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {
    [SET_EMPRESAS](state, empresas) {
        state.empresas = empresas;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};